import { Mutation } from '@varo/graphql-schema-types';
import ChatReadReceipt from 'services/graphql/mutations/Chat/ChatReadReceipt';
import { getUuid } from 'shared/utils/getUuid/getUuid';
import { CombinedError, useMutation } from 'urql';

interface ReadReceiptOutput {
  fetching: boolean;
  error?: CombinedError;
  ackChatMsg: (id: string) => void;
}

const useReadReceipt = (): ReadReceiptOutput => {
  const [{ fetching, error }, ackChat] = useMutation<Mutation>(ChatReadReceipt);

  const ackChatMsg = (id: string) => {
    void ackChat({
      idempotencyId: getUuid(),
      input: {
        id,
        createdAt: new Date().toISOString(),
      },
    });
  };
  return {
    fetching,
    error,
    ackChatMsg,
  };
};

export default useReadReceipt;
